<section class="claim-details-faqs-block smart-fix-banner section-spacing">
  <div class="smart-fix-banner__content">
    <h3>{{ smartFixBanner.title }}</h3>
    <p>{{ smartFixBanner.contentText }}</p>
    <dgx-components-button-link
      variant="secondary"
      [navigationLink]="smartFixLink"
      [newWindow]="true"
      (click)="sendToGA()"
      iconName="arrow-right"
    >
      {{ smartFixBanner.buttonText }}
    </dgx-components-button-link>
  </div>
  <div class="smart-fix-banner__background">
    <img
      [src]="magnoliaSrc + smartFixBanner.image.cmsSrc['@link']"
      [alt]="smartFixBanner.image.alt"
      role="presentation"
    />
  </div>
</section>
